import { render, staticRenderFns } from "./EditPwd.vue?vue&type=template&id=a363e586&scoped=true&"
import script from "./EditPwd.vue?vue&type=script&lang=js&"
export * from "./EditPwd.vue?vue&type=script&lang=js&"
import style0 from "./EditPwd.vue?vue&type=style&index=0&id=a363e586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a363e586",
  null
  
)

export default component.exports